/**
 * External Dependencies
 */
import 'jquery';

// Alpine
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import persist from '@alpinejs/persist';

// Flickity
var Flickity = require('flickity-fade');

$(() => {
  // console.log('Hello world');

  // Alpine
  Alpine.plugin(intersect)
  Alpine.plugin(persist)
  window.Alpine = Alpine
  Alpine.start()

  // Flickity
  if ($('.slider')[0]) {
    var flkty = new Flickity('.slider');
    $('.slider .js-next').on('click', function () {
      flkty.next();
    });
    $('.slider .js-previous').on('click', function () {
      flkty.previous();
    });
  }
});
